// Privacy.js
import React from "react";
import { Link } from "react-router-dom";
import "../Terms.css";

function Privacy() {
  return (
    <div className="terms-page">
      <header className="app-bar" role="banner">
        <div className="app-bar__inner">
          <Link to="/ja" className="brand-link" aria-label="メインページへ戻る">
            TooLoves
          </Link>
        </div>
      </header>

      <main id="content" role="main" className="container" aria-labelledby="privacy-title">
        <article className="generator-card terms-card" aria-labelledby="privacy-title">
          <header className="terms-header">
            <h1 id="privacy-title" className="card-title">TooLoves.net プライバシーポリシー</h1>
            <p className="card-subtitle terms-updated">
              最終更新日:
              <time dateTime="2025-10-22"> 2025年10月22日（KST）</time>
            </p>
          </header>

          <section className="terms-section">
            <p>
              本プライバシーポリシー（以下「本ポリシー」）は、TooLoves.net（以下「当サイト」）の運営者が
              利用者の個人情報をどのように取り扱うかを説明するものです。当サイトを利用することで、
              利用者は本ポリシーに同意したものとみなされます。
            </p>
          </section>

          <section className="terms-section" id="info-collection">
            <h2 className="section-title">1. 収集する個人情報</h2>
            <p>
              当サイトは、氏名・メールアドレス・IPアドレス等の個人を特定できる情報を直接収集しません。
              QRコード生成、画像ウォーターマーク、EXIF抽出などの機能はすべて利用者の端末上で処理され、
              画像やデータがサーバーへアップロードまたは送信されることはありません。
            </p>
            <p>
              ただし、当サイトではサービス品質の向上および利用状況の解析のために
              <strong> Google Analytics（GA4）</strong> を使用しています。Google はクッキー等を活用して、
              アクセス端末情報、閲覧したページ、滞在時間、クリックイベント、ブラウザの種類、接続地域（都市レベルの位置情報）などの
              <strong> 非識別データを自動的に収集</strong> する場合があります。
              これらのデータは個人を特定するものではなく、サイト運営およびサービス改善の目的に限り使用されます。
            </p>
          </section>

          <section className="terms-section" id="use-of-info">
            <h2 className="section-title">2. 個人情報の利用目的</h2>
            <p>
              収集された情報は、サイトのトラフィック分析、エラー診断、サービス改善などの統計的な目的にのみ利用されます。
              当サイトは Google Analytics（GA4）、Netlify、ならびに Google AdSense のポリシーに従います。
            </p>
          </section>

          <section className="terms-section" id="data-sharing">
            <h2 className="section-title">3. 個人情報の提供・共有</h2>
            <p>
              当サイトは個人情報を直接収集・保存しません。
              ただし、サービス提供に利用している Netlify、Google AdSense、および Google Analytics によって
              自動的な収集が発生する場合があります。これらの過程で収集される情報は、各サービス提供者の
              プライバシーポリシーに従って管理されます。
            </p>
          </section>

          <section className="terms-section" id="data-security">
            <h2 className="section-title">4. 個人情報の保護</h2>
            <p>
              当サイトは個人情報を保存しておらず、サイト運営に必要なインフラは
              <strong> Netlify</strong> のセキュリティポリシーに準拠しています。また、広告および統計解析には
              <strong> Google AdSense</strong> と <strong> Google Analytics</strong> のセキュリティ体制が適用されます。
            </p>
            <p>
              利用者はブラウザ設定でクッキーの使用を拒否するか、
              <a
                href="https://tools.google.com/dlpage/gaoptout"
                target="_blank"
                rel="noopener noreferrer"
              >
                Google Analytics オプトアウト アドオン
              </a>
              をインストールしてデータ収集を無効化できます。
            </p>
          </section>

          <section className="terms-section" id="policy-changes">
            <h2 className="section-title">5. ポリシーの変更</h2>
            <p>
              運営者は必要に応じて本プライバシーポリシーを変更することがあり、変更時にはサイト上の告知または本ページでお知らせします。
            </p>
            <p>
              変更後もサービスを継続して利用された場合、変更後のポリシーに同意したものとみなします。
            </p>
          </section>

          <section className="terms-section" id="contact">
            <h2 className="section-title">6. お問い合わせ</h2>
            <p>
              サービスに関するお問い合わせは{" "}
              <a
                href="mailto:helptooloves@gmail.com"
                className="mailto-link"
                aria-label="helptooloves@gmail.com へメールを送る"
              >
                helptooloves@gmail.com
              </a>
              までご連絡ください。
            </p>
          </section>

          <div className="terms-actions">
            <Link to="/ja" className="btn" aria-label="メインページへ戻る">
              メインページへ戻る
            </Link>
          </div>
        </article>
      </main>

      <footer className="footer" role="contentinfo">
        © 2025 TooLoves. All rights reserved.
      </footer>
    </div>
  );
}

export default Privacy;